import Ajax from "../../lib/ajax";
import util from "../../lib/util";
import BillingAccount from "../entities/billingAccount";
import FreeTrialAccount from "../entities/freeTrialAccount";
import inviteNotification from "../entities/inviteNotification";
import PricePlan from "../entities/price-plan";
import { Store, Module, ActionContext } from "vuex";

interface BillingState {
  loading: boolean;
  billingAccount: BillingAccount;
  freeTrialAccounts: FreeTrialAccount[];
  noticeSpinShow: boolean;
  inviteNotifications: inviteNotification[];
  noticeList: any[];
  pricePlans: PricePlan[];
}

class BillingStore implements Module<BillingState, any> {
  namespaced = true;
  state = {
    loading: false,
    billingAccount: null,
    freeTrialAccounts: [],
    noticeSpinShow: false,
    inviteNotifications: new Array<inviteNotification>(),
    pricePlans: [],
    noticeList: []
  };
  getters = {};
  actions = {
    async getFreeTrials(context: ActionContext<BillingState, any>) {
      context.state.loading = true;

      return Ajax.get("/api/services/app/Billing/GetFreeTrials")
        .then(response => {
          context.state.freeTrialAccounts = response.data.result.freeTrials as FreeTrialAccount[];
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async extendFreeTrial(context: ActionContext<BillingState, any>, payload: any) {
      context.state.loading = true;
      return Ajax.post("/api/services/app/Billing/ExtendFreeTrial", payload.data)
        .then(response => {
          if (response.data.result.success === true) {
            context.dispatch("getFreeTrials");
          }

          return response;
        })
        .finally(() => {
          context.state.loading = false;
        });
    },
    async getInviteNotifications(context: ActionContext<BillingState, any>, payload: any) {
      context.state.noticeSpinShow = true;
      await Ajax.get("/api/services/app/BillingAccountInvitation/GetInviteNotifications")
        .then(response => {
          context.state.inviteNotifications = response.data.result;
          context.state.noticeList = context.state.inviteNotifications.map(invitation => {
            return {
              type: 0,
              read: false,
              title: `Join "${invitation.accountName}"`,
              description: `From ${invitation.inviterName}`,
              invitation: invitation
            };
          });
        })
        .finally(() => {
          context.state.noticeSpinShow = false;
        });
    }
  };
}
export default new BillingStore();
